import {
    UntypedFormArray,
    UntypedFormControl,
    UntypedFormGroup,
    type AbstractControl,
    type ValidationErrors,
    type ValidatorFn
} from '@angular/forms';

export function createControlValidator(controlValidator: (control: UntypedFormControl) => ValidationErrors | null): ValidatorFn {
    return (abstractControl: AbstractControl) => {
        if (!((abstractControl as any) instanceof UntypedFormControl)) {
            throw new Error('used FormControl validator with another type of control');
        }
        return controlValidator(abstractControl as UntypedFormControl);
    };
}

export function createGroupValidator(groupValidator: (group: UntypedFormGroup) => ValidationErrors | null): ValidatorFn {
    return (abstractControl: AbstractControl) => {
        if (!((abstractControl as any) instanceof UntypedFormGroup)) {
            throw new Error('used FormControl validator with another type of control');
        }
        return groupValidator(abstractControl as UntypedFormGroup);
    };
}

export function createArrayValidator(arrayValidator: (array: UntypedFormArray) => ValidationErrors | null): ValidatorFn {
    return (abstractControl: AbstractControl) => {
        if (!((abstractControl as any) instanceof UntypedFormArray)) {
            throw new Error('used FormControl validator with another type of control');
        }
        return arrayValidator(abstractControl as UntypedFormArray);
    };
}
